import {ConferencePublication} from "./ConferencePublication";
import {functions} from "../app/Firebase";

export const publishConference = async (conferenceId: string): Promise<ConferencePublication> => {
    const publishConference = functions.httpsCallable("publishConference");
    const result = await publishConference(conferenceId);
    return result.data;
};
